const DB_NAME =
    "arento_push_v2";

const DB_VERSION =
    1;

const STATE_STORE =
    "state";

const PENDING_STORE =
    "pendingOperations";


let openPromise =
    null;


const openDb = () => {
    if (
        typeof indexedDB ===
        "undefined"
    ) {
        return Promise.reject(
            new Error(
                "IndexedDB не поддерживается"
            )
        );
    }


    if (
        openPromise
    ) {
        return openPromise;
    }


    openPromise =
        new Promise(
            (
                resolve,
                reject
            ) => {
                const request =
                    indexedDB.open(
                        DB_NAME,
                        DB_VERSION
                    );


                request.onupgradeneeded =
                    () => {
                        const db =
                            request.result;


                        if (
                            !db.objectStoreNames
                                .contains(
                                    STATE_STORE
                                )
                        ) {
                            db.createObjectStore(
                                STATE_STORE
                            );
                        }


                        if (
                            !db.objectStoreNames
                                .contains(
                                    PENDING_STORE
                                )
                        ) {
                            const store =
                                db.createObjectStore(
                                    PENDING_STORE,
                                    {
                                        keyPath:
                                            "id"
                                    }
                                );


                            store.createIndex(
                                "nextAttemptAt",
                                "nextAttemptAt",
                                {
                                    unique:
                                        false
                                }
                            );
                        }
                    };


                request.onsuccess =
                    () => {
                        const db =
                            request.result;


                        db.onversionchange =
                            () => {
                                db.close();

                                openPromise =
                                    null;
                            };


                        resolve(
                            db
                        );
                    };


                request.onerror =
                    () => {
                        openPromise =
                            null;

                        reject(
                            request.error ||
                            new Error(
                                "Не удалось открыть push IndexedDB"
                            )
                        );
                    };


                request.onblocked =
                    () => {
                        console.warn(
                            "Push IndexedDB upgrade blocked"
                        );
                    };
            }
        );


    return openPromise;
};


const runRequest = (
    request
) => {
    return new Promise(
        (
            resolve,
            reject
        ) => {
            request.onsuccess =
                () =>
                    resolve(
                        request.result
                    );


            request.onerror =
                () =>
                    reject(
                        request.error
                    );
        }
    );
};


export const getPushState =
    async (
        key
    ) => {
        const db =
            await openDb();


        const transaction =
            db.transaction(
                STATE_STORE,
                "readonly"
            );


        const store =
            transaction.objectStore(
                STATE_STORE
            );


        return runRequest(
            store.get(
                key
            )
        );
    };


export const setPushState =
    async (
        key,
        value
    ) => {
        const db =
            await openDb();


        const transaction =
            db.transaction(
                STATE_STORE,
                "readwrite"
            );


        const store =
            transaction.objectStore(
                STATE_STORE
            );


        await runRequest(
            store.put(
                value,
                key
            )
        );
    };


export const deletePushState =
    async (
        key
    ) => {
        const db =
            await openDb();


        const transaction =
            db.transaction(
                STATE_STORE,
                "readwrite"
            );


        const store =
            transaction.objectStore(
                STATE_STORE
            );


        await runRequest(
            store.delete(
                key
            )
        );
    };


export const getPushDeviceCredential =
    async () => {
        const value =
            await getPushState(
                "deviceCredential"
            );


        if (
            !value?.deviceId ||
            !value?.deviceSecret
        ) {
            return null;
        }


        return {
            deviceId:
            value.deviceId,

            deviceSecret:
            value.deviceSecret,

            ownershipVersion:
                Number(
                    value.ownershipVersion ||
                    1
                ),

            updatedAt:
                value.updatedAt ||
                null
        };
    };


export const savePushDeviceCredential =
    async ({
               deviceId,
               deviceSecret,
               ownershipVersion = 1
           }) => {
        if (
            !deviceId ||
            !deviceSecret
        ) {
            throw new Error(
                "Нельзя сохранить пустой device credential"
            );
        }


        await setPushState(
            "deviceCredential",
            {
                deviceId,

                deviceSecret,

                ownershipVersion:
                    Number(
                        ownershipVersion ||
                        1
                    ),

                updatedAt:
                    new Date()
                        .toISOString()
            }
        );
    };


export const clearPushDeviceCredential =
    async () => {
        await deletePushState(
            "deviceCredential"
        );
    };


export const savePushRuntimeConfig =
    async ({
               apiBase,
               vapidPublicKey
           }) => {
        const previous =
            await getPushState(
                "runtimeConfig"
            ) ||
            {};


        await setPushState(
            "runtimeConfig",
            {
                ...previous,

                apiBase:
                    apiBase ??
                    previous.apiBase ??
                    "",

                vapidPublicKey:
                    vapidPublicKey ??
                    previous.vapidPublicKey ??
                    null,

                updatedAt:
                    new Date()
                        .toISOString()
            }
        );
    };


export const getPushRuntimeConfig =
    async () => {
        return (
            await getPushState(
                "runtimeConfig"
            )
        ) || {
            apiBase:
                "",

            vapidPublicKey:
                null
        };
    };


/*
 * Эти операции frontend пока почти не использует.
 *
 * Store создаём уже сейчас, потому что следующим
 * шагом Service Worker будет складывать сюда
 * неотправленные reconcile / ACK / click.
 */
export const putPendingPushOperation =
    async (
        operation
    ) => {
        const db =
            await openDb();


        const transaction =
            db.transaction(
                PENDING_STORE,
                "readwrite"
            );


        const store =
            transaction.objectStore(
                PENDING_STORE
            );


        await runRequest(
            store.put(
                operation
            )
        );
    };


export const deletePendingPushOperation =
    async (
        id
    ) => {
        const db =
            await openDb();


        const transaction =
            db.transaction(
                PENDING_STORE,
                "readwrite"
            );


        await runRequest(
            transaction
                .objectStore(
                    PENDING_STORE
                )
                .delete(
                    id
                )
        );
    };